<template>
  <div class="aiPanelDes ProEkran" style="height: calc(100vh - 120px)">
    <Yukleniyor :data="lo"></Yukleniyor>
    <div class="aiPanelHead yazdirma">
      <p>
        <i class="el-icon-document-copy text-success"></i>
        Fatura
      </p>
      <el-date-picker
        :clearable="false"
        @change="SayfaYukle"
        size="small"
        v-model="Tarih"
        type="daterange"
        range-separator="-"
        start-placeholder="Başlangıç Tarihi"
        end-placeholder="Bitiş Tarihi"
        format="dd.MM.yyyy">
      </el-date-picker>
    </div>
    <el-table
      class="table-xs cursor-pointer yazdirma"
      style="width: 100%"
      width="100%"
      :data="Liste"
      v-if="Liste"
      show-summary
      :summary-method="TableFooter"
      :height="Height"
      @current-change="FaturaSecimi">
      <el-table-column
        prop="Tarih"
        label="Tarih"
        width="80">
      </el-table-column>
      <el-table-column
        prop="Bina"
        label="Bina Adı">
      </el-table-column>
      <el-table-column
        prop="Tutar"
        label="Tutar"
        align="right"
        width="80">
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
import Yukleniyor from "../../../components/Doc/Yukleniyor";

export default {
  components: {Yukleniyor},
  data() {
    return {
      Tarih: [],
      lo: false,
      Liste: null,
      AltToplam: null,
      Modal: false,
      FaturaData: null,
      Height:null
    }
  },
  methods: {
    FaturaSecimi(val) {
      this.$emit('Data', val);
    },
    SayfaYukle() {
      this.lo = true;
      this.$store.dispatch("Post", {Tarih: this.Tarih, path: '_sim/fatura'})
        .then(response => {
          this.lo = false;
          if (response.Durum === 'OK') {
            this.AltToplam = response.AltToplam;

            this.Liste = response.Data;
            this.Height = window.innerHeight - 170
          } else {
            this.$message.error(response.Mesaj);
          }
        });
    },
    TableFooter() {
      const sums = [];
      sums[2] = this.AltToplam;
      return sums;
    },
  },
  created() {
    var Gun = new Date();
    this.Tarih[0] = new Date(Gun.getFullYear(), Gun.getMonth(), 1);
    this.Tarih[1] = new Date(Gun.getFullYear(), Gun.getMonth() + 1, 0);
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/_Sim/Comp/BinaFatura.vue